import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

export default class ScrollFunc {
    constructor() {
        this.baseDeviceWidth = getComputedStyle(document.documentElement).getPropertyValue('--baseDeviceWidth'); //cssから取得
        this.init();
    }

    init() {
        this.smoothScroll();
        window.addEventListener('load', this.onScroll);
    }

    refresh() {
        ScrollTrigger.refresh();
    }

    onScroll() {
        const revealElm = document.querySelectorAll('.js-scrollreveal');

        [...revealElm].forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: 'top 80%',
                //markers: true,
                onEnter: () => {
                    el.classList.add('-reveal');
                },
            });
        });

        const funcElm = document.querySelectorAll('.js-scrollfunc');

        [...funcElm].forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: 'top 80%',
                //markers: true,
                onEnter: () => {
                    el.classList.add('-scrollin');
                },
            });
        });
    }

    smoothScroll() {
        const triggers = document.querySelectorAll('.js-smoothscroll');
        const pagetop = document.querySelectorAll('.js-pagetop');

        triggers.forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                const hash = el.getAttribute('href');
                const offset = 50;
                gsap.to(window, { duration: 1, scrollTo: { y: hash, offsetY: offset }, ease: 'circ.inOut' });
            });
        });

        pagetop.forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                gsap.to(window, { duration: 1, scrollTo: { y: 0 }, ease: 'circ.inOut' });
            });
        });
    }
}
